import axiosInstance from './axiosInstance';

const API_URL = () => process.env.REACT_APP_API_URL;

// GET all expenseCodes
export const getExpenseCodes = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL()}/expense-codes`);
    return response.data;
  } catch (error) {
    console.error("Error fetching expenseCodes:", error.response?.data || error);
    throw error;
  }
};

// GET a single expenseCode
export const getExpenseCodeById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL()}/expense-codes/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching expenseCode:", error.response?.data || error);
    throw error;
  }
};

// CHECK for duplicate expense code
export const checkExpenseCodeDuplicate = async ({ code, name, id }) => {
  try {
    const params = new URLSearchParams();
    if (code) params.append('code', code);
    if (name) params.append('name', name);
    if (id) params.append('excludeId', id);
    const url = params.toString()
      ? `${API_URL()}/expense-codes/check?${params.toString()}`
      : `${API_URL()}/expense-codes/check`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error(
      'Error checking duplicate expenseCode:',
      error.response?.data || error,
    );
    throw error;
  }
};

// CREATE a new expenseCode
export const createExpenseCode = async (expenseCodeData) => {
  try {
    const response = await axiosInstance.post(`${API_URL()}/expense-codes`, expenseCodeData);
    return response.data;
  } catch (error) {
    console.error("Error creating expenseCode:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing expenseCode
export const updateExpenseCode = async (id, expenseCodeData) => {
  try {
    const response = await axiosInstance.put(`${API_URL()}/expense-codes/${id}`, expenseCodeData);
    return response.data;
  } catch (error) {
    console.error("Error updating expenseCode:", error.response?.data || error);
    throw error;
  }
};

// DELETE a expenseCode
export const deleteExpenseCode = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL()}/expense-codes/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting expenseCode:", error.response?.data || error);
    throw error;
  }
};
